import { PlusIcon } from "@phosphor-icons/react/Plus";
import { Button } from "@freightsimple/ui-core/Controls/Button";

interface AddCreditCardButtonProps {
  onClick: () => void;
}

export function CreditCardsAddButton(props: AddCreditCardButtonProps) {
  return (
    <Button
      primary
      size="large"
      icon={PlusIcon}
      iconWeight="fill"
      onClick={props.onClick}
    >
      Add New Credit Card
    </Button>
  );
}
